/* ACCOUNT_STATEMENTS */
export const GET_ACCOUNT_STATEMENTS = "GET_ACCOUNT_STATEMENTS";
export const GET_ACCOUNT_STATEMENTS_SUCCESS = "GET_ACCOUNT_STATEMENTS_SUCCESS";
export const GET_ACCOUNT_STATEMENTS_FAIL = "GET_ACCOUNT_STATEMENTS_FAIL";
export const GET_BANK_STATEMENTS = "GET_BANK_STATEMENTS";
export const GET_BANK_STATEMENTS_SUCCESS = "GET_BANK_STATEMENTS_SUCCESS";
export const GET_BANK_STATEMENTS_FAIL = "GET_BANK_STATEMENTS_FAIL";
